<template>
  <RouterLink custom :to="to" v-slot="{ href, navigate }">
    <li :class="{ active: isActive(href)}">
      <a :href="href" @click="navigate">
        <span class="material-icons" v-tooltip="tooltip || false" v-if="icon">{{icon}}</span>
        <span class="text">{{ label }}</span>
        <p-badge :value="notifications" severity="danger" v-if="notifications" class="notifications mt0 self-center justify-center" />
      </a>
    </li>
  </RouterLink>
</template>
<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';
import { useRoute } from 'vue-router';

// Data
const route = useRoute();

// Props
withDefaults(defineProps<{
  to?: RouteLocationRaw;
  icon?: string;
  tooltip?: string;
  notifications?: number;
  label?: string;
}>(), {
  to: '/',
});

// Functions
function isActive(href: string) {
  return route.fullPath.toLowerCase() === href.toLowerCase();
}
</script>
